export interface WalletItem {
  id?: string;
  type: string;
  address: string;
  tx?: string;
  active?: boolean;
  usdt: string;
  createdAt: number;
  native: string;
  balance: string;
}

export enum WalletType {
  BITCOIN = "Bitcoin",
  Tron = "Tron",
  ETHEREUM = "Ethereum",
}
